import { useState } from 'react'

import type { ReportChartSpec } from '../../stores/types'
import {
  availableSankeyViews,
  chartSpecForView,
  DEFAULT_SANKEY_VIEW,
  type SankeyView,
} from './sankeyViews'

// A picked view that the chart no longer offers falls back to All.
export function useSankeyView(spec: ReportChartSpec) {
  const [pickedView, setPickedView] = useState<SankeyView>(DEFAULT_SANKEY_VIEW)
  const views = availableSankeyViews({
    nodes: spec.nodes ?? [],
    links: spec.links ?? [],
  })
  const view = views.includes(pickedView) ? pickedView : DEFAULT_SANKEY_VIEW
  return {
    views,
    view,
    setView: setPickedView,
    shownSpec: chartSpecForView(spec, view),
  }
}
